/**
 * Assessment display helpers
 */
import { ItemEvaluation } from '@app-types';

interface GapsIdentifiedSource {
  gaps_remediated_count?: number | null;
  gaps_not_remediated_count?: number | null;
}

/**
 * Total gaps identified in an assessment, including those already remediated.
 */
export function getGapsIdentifiedCount(assessment: GapsIdentifiedSource): number {
  return (assessment.gaps_remediated_count ?? 0) + (assessment.gaps_not_remediated_count ?? 0);
}

// The backend stamps every saved note as "[YYYY-MM-DD | Author] text" and stamps it again on each save,
// so the stamp must be removed before the note is offered for editing.
const EVALUATION_NOTE_STAMP = /^\[\d{4}-\d{2}-\d{2} \| [^\]]*\] /;

/**
 * Saved evaluation notes without the leading date/author stamp.
 */
export function stripEvaluationNoteStamp(notes: string | null | undefined): string {
  return (notes ?? '').replace(EVALUATION_NOTE_STAMP, '');
}

/**
 * The evaluation option to preselect when re-evaluating a process.
 * System-set states (Remediated, Expired) and Not Assessed preselect nothing.
 */
export function getPrefillEvaluation(evaluation: ItemEvaluation | null | undefined): ItemEvaluation | '' {
  switch (evaluation) {
    case 'Implemented':
    case 'Implemented (Needs Evidence)':
      return 'Implemented';
    case 'Gap':
      return 'Gap';
    case 'Not Applicable':
      return 'Not Applicable';
    default:
      return '';
  }
}
